'use strict';

import { highlight } from '../../helpers/helpers';

export default {
  init() {
    const pub = document.querySelector('.node--type-publication-listing');
    if (pub) {
      this.finalize(pub);
    }
  },

  finalize(element) {
    const urlParams = new URLSearchParams(window.location.search);
    const searchQuery = urlParams.get('search_query');

    if (!searchQuery) {
      return;
    }

    const searchWords = searchQuery
      .toLowerCase()
      .split(/\s+/)
      .filter(word => word.length > 0);

    if (searchWords.length === 0) {
      return;
    }

    const pubItemTitles = element.querySelectorAll('.node-publication-listing h3');
    const personName = element.querySelectorAll('.node-publication-listing__meta .person_name');

    pubItemTitles.forEach(el => {
      highlight(searchWords, el);
    });

    personName.forEach(el => {
      highlight(searchWords, el);
    });
  },
};
